<template>
  <div class="order_list_box">
    <van-nav-bar
      title="我的订单"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    />
    <div class="out_box">
      <div class="search_header">
        <van-search
          v-model="serachContent"
          :clearable="false"
          placeholder="车架号/车牌号/投保人"
        >
          <!-- <template #left-icon>
            <img class="search_icon" :src="searchImage" alt="">
          </template> -->
          <template #right-icon>
            <div class="serach_text" @click="handleSearch">
              搜索
            </div>
          </template>
        </van-search>
      </div>
    </div>
    <div class="tab_list">
      <van-tabs v-model="active" @change="changeTab">
        <van-tab
          v-for="(item, index) in tabList"
          :key="index"
          :title="item.title"
          :name="item.name"
        />
      </van-tabs>
      <div v-if="!showContent" class="empty-box">
        <img :src="emptyImgUrl" alt="">
        <!-- <p>暂无数据</p> -->
      </div>
      <van-list
        v-else
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :offset="offset"
        :immediate-check="immediateCheck"
        @load="onLoad"
      >
        <div>
          <div
            v-for="(item, index) in dataList"
            :key="index"
            class="order_list"
            @click="toDetail(item.orderNo, item)"
          >
            <div class="order_item">
              <div class="header flex_box">
                <p>{{ item.licenseNo }}</p>
                <p
                  v-if="item.orderStatus === '3' || item.orderStatus === '1'"
                  class="tip-text"
                >
                  {{ typeObj[item.orderStatus] }}
                </p>
              </div>
              <div class="content">
                <div class="flex_box">
                  <p class="label">
                    投保人：{{ item.appliName }}
                  </p>
                </div>
                <div class="flex_box">
                  <p class="label">
                    订单号：{{ item.orderNo }}
                  </p>
                </div>
                <div class="flex_box">
                  <p class="label">
                    订单时间：{{ item.inputDate }}
                  </p>
                </div>
                <div v-show="item.orderStatus === '4'" class="flex_box">
                  <p class="label">
                    支付时间：{{ item.payDate }}
                  </p>
                </div>
                <div v-if="item.orderStatus !=='0'" class="flex_box">
                  <p class="amount_text">
                    保费： <span class="amount"> ￥{{ item.sumPremium }} </span>
                  </p>
                </div>
                <div v-show="item.orderStatus === '3'">
                  <div class="detail_box">
                    <div class="text_box">
                      <p ref="detailDom" class="amount detail_text">
                        {{ item.underWriteMessage }}
                      </p>
                      <p v-show="item.showMore" class="look_more" @click.stop="lookMore(item.underWriteMessage)">
                        查看意见>>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="item.orderStatus === '2' || item.orderStatus == '0'" class="footer-btn">
                <div
                  class="btn-item"
                  @click.stop="cancelOrder(item)"
                >
                  删除
                </div>
              </div>
              <img
                v-if="item.orderStatus === '4'"
                class="pay_logo"
                :src="payTips"
                alt=""
              >
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="bottom" @click.prevent="addOrder">
      <div><img class="add-text" :src="addText" alt=""></div>
      <div><img class="add" :src="addImg" alt=""></div>
    </div>
    <Loading :switchs="switchs" />
  </div>
</template>

<script>
import api from '@/api/api.js'
import Loading from '@/components/Loadings/Loading'
import { Toast, Dialog } from 'vant'
import { removeWatermark, setWaterMark } from '../../watermark'
import checkFormat from '@/utils/checkFormat.js'
export default {
  components: {
    Loading
  },
  data() {
    return {
      showMore: false,
      immediateCheck: false,
      offset: 50,
      loading: false,
      finished: false,
      payTips: api.imgAllUrlZSB + '/pay-tips.png',
      switchs: false,
      active: '',
      showContent: true,
      emptyImgUrl: api.imgAllUrlZSB + '/empty-logo.png',
      searchImage:
        'https://open.zking.com/cms/uploads/45/internet-static/zki-cside-car/images/common/searchIcon.png',
      PayImage:
        'https://open.zking.com/cms/uploads/45/internet-static/zki-cside-car/images/common/payLogo.png',
      addImg: api.imgAllUrlZSB + '/order-add-btn.png',
      addText: api.imgAllUrlZSB + '/order-add-text.png',
      insureTipsImage: api.newImgAllUrl + '/insureTips.png',
      addImage: api.newImgAllUrl + '/addIcon.png',
      insureTips: api.newImgAllUrl + '/insureTips.png',
      total: 0,
      pageNum: 0,
      pageSize: 10,
      orderStatus: '',
      dataList: [],
      typeObj: {
        '3': '下发修改',
        '2': '待支付',
        '4': '已支付',
        '1': '核保中'
      },
      tabList: [
        {
          title: '全部',
          name: '0'
        },
        {
          title: '下发修改',
          name: '1'
        },
        {
          title: '暂存',
          name: '2'
        },
        {
          title: '待支付',
          name: '3'
        },
        {
          title: '已支付',
          name: '4'
        }
      ],
      allList: [],
      underEditList: [],
      waitPayList: [],
      finishPayList: [],
      serachContent: ''
    }
  },
  watch: {
    dataList: function(newVal) {
      if (newVal) {
        this.showDetailBtn()
      }
    }
  },
  mounted() {
    this.queryPageList(this.serachContent, true)
    if (localStorage.getItem('cInfo')) {
      this.cInfo = JSON.parse(localStorage.getItem('cInfo'))
      this.cInfo.name = checkFormat.hideInsurantName(1, this.cInfo.name)
      this.cInfo.identifyNum = checkFormat.hideInsurantName(
        3,
        this.cInfo.identifyNum
      )
      setWaterMark(this.cInfo.name + '-' + this.cInfo.identifyNum)
    }
  },
  deactivated() {
    removeWatermark()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },

    queryPageList(searchValue, isClear) {
      // 订单状态(0暂存；1核保中；2待支付；3下发修改；4生效；5失效；6退保)
      this.switchs = true
      if (isClear) {
        this.dataList = []
        this.pageNum = 0
      }
      const obj = {
        0: '',
        1: '3',
        2: '0',
        3: '1,2',
        4: '4'
      }
      console.log(this.active, 'active')
      console.log(obj[this.active], 'objActive')
      const params = {
        condition: searchValue.trim() || this.serachContent.trim(),
        orderStatus: obj[this.active] || '',
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$http.post(api.queryCOrderList, params).then(res => {
        if (res.data.rtnCode === '0000') {
          const reqList = res.data.cusOrderDtoList.content
          if (reqList && reqList.length > 0) {
            reqList.forEach(item => {
              this.dataList.push(item)
            })
          }
          this.pageNum = res.data.cusOrderDtoList.pageNum
          this.total = res.data.cusOrderDtoList.totalCount
          this.finished = this.total <= this.dataList.length
          this.showContent = this.dataList.length > 0
          this.loading = false
          this.switchs = false
        } else {
          Toast({
            message: res.data.rtnMsg,
            duration: 2000
          })
          this.showContent = false
          this.switchs = false
        }
      }).catch(err => {
        console.log(err)
        this.showContent = false
        this.switchs = false
      })
    },
    onLoad() {
      this.pageNum++
      this.queryPageList(this.serachContent)
    },
    changeTab() {
      this.queryPageList(this.serachContent, true)
    },
    handleSearch() {
      this.queryPageList(this.serachContent, true)
    },
    showDetailBtn() {
      this.$nextTick(() => {
        const detailDom = this.$refs.detailDom
        console.log(this.dataList)
        this.dataList.forEach(item => {
          detailDom.forEach(el => {
            this.$set(item, 'showMore', el.clientHeight < el.scrollHeight)
          })
        })
      })
    },
    lookMore(message) {
      Dialog.alert({
        message: message,
        confirmButtonText: '确定',
        confirmButtonColor: '#592581'
      }).then(() => {
        // on close
      })
    },
    cancelOrder(item) {
      Dialog.confirm({
        // title: '标题',
        message: '是否确认删除？',
        confirmButtonText: '确认',
        confirmButtonColor: '#592581',
        cancelButtonText: '取消'
      })
        .then(() => {
          if (item.orderStatus !== '0') {
            const params = {
              businessNo: item.orderNo,
              encryptKey: item.encryptKey,
              serverName: 'DP_OWXPA'
            }
            this.switchs = true
            this.$http.post(api.cancelWaitPayOrder, params).then(res => {
              this.switchs = false
              if (res.data.rtnCode === '0000') {
                // Toast.success('删除成功！')
                this.queryPageList(this.serachContent, true)
              } else {
                Toast.fail(res.data.rtnMsg)
              }
            })
          } else {
            const dataObj = {
              orderNo: item.orderNo,
              orderId: item.orderId,
              deletedFlag: 'Y'
            }
            this.switchs = true
            this.$http.post(api.motorSava, dataObj).then(res => {
              this.switchs = false
              if (res.data.rtnCode === '0000') {
                // Toast.success('删除成功！')
                this.queryPageList(this.serachContent, true)
              } else {
                Toast.fail(res.data.rtnMsg)
              }
            })
          }
        })
        .catch(() => {
          // on cancel
          this.switchs = false
        })
    },
    toDetail(orderNo, list) {
      // console.log(orderNo, list, 'orderNo, list')
      if (list.orderStatus === '3' || list.orderStatus === '0') {
        const data = {
          businessNo: list.orderNo,
          encryptKey: list.encryptKey,
          serverName: 'DP_OWXPA',
          orderId: list.orderId
        }
        this.switchs = true
        this.$http.post(api.queryOrderDetail + `?fileContentFlag=0&orderId=${list.orderId}`)
          .then(resTwo => {
            Toast.clear()
            this.switchs = false
            if (resTwo.data.rtnCode === '0000') {
              const returnData = {
                vehicleInfo: resTwo.data.resultObj.vehicleInfo,
                carOwnerInfo: resTwo.data.resultObj.carOwnerInfo,
                insuredList: resTwo.data.resultObj.insuredList,
                taxRelifInfo: resTwo.data.resultObj.taxRelifInfo,
                submitInfo: resTwo.data.resultObj.submitInfo,
                engageList: resTwo.data.resultObj.engageList,
                orderId: resTwo.data.resultObj.orderId,
                orderNo: resTwo.data.resultObj.orderNo,
                itemFileDataList: resTwo.data.resultObj.itemFileDataList,
                baseInfo: resTwo.data.resultObj.baseInfo,
                orderAmount: resTwo.data.resultObj.orderAmount,
                encryptKey: data.encryptKey,
                carPolicySubInfoList: resTwo.data.resultObj.carPolicySubInfoList
              }
              // this.$store.commit('set_motorOrderId', returnData.orderId)
              this.$store.commit('set_motorComCode', returnData.baseInfo.comCode)
              this.$store.commit('set_motorOrderDetail', returnData)
              // console.log(this.$store.state.motorOrderDetail, '0009999999')
              this.$store.commit('setItemFileDataList', returnData.itemFileDataList)
              this.$store.commit('set_motorBaseInfo', returnData.vehicleInfo)
              this.$store.commit('set_motorOrderId', returnData.orderId)
              this.$store.commit('setCarOwnerInfo', returnData.carOwnerInfo)
              this.$store.commit('setInsuredList', returnData.insuredList)
              console.log(returnData, 'returnData====?')
              if (returnData.insuredList && Object.keys(returnData.insuredList).length > 0 && returnData.insuredList[0].insuredName && parseInt(returnData.orderAmount) === 0) {
                this.$router.push('/motor/personInfo')
              } else if ((returnData.vehicleInfo && Object.keys(returnData.vehicleInfo).length > 0 && returnData.orderId && parseInt(returnData.orderAmount) === 0 && returnData.insuredList === null) || returnData.vehicleInfo.colorCode === '') {
                this.$router.push({ name: 'BaseInfo', params: { data: data }})
              } else if (returnData.taxRelifInfo && Object.keys(returnData.taxRelifInfo).length > 0 && parseInt(returnData.orderAmount) > 0 && (returnData.engageList === null || returnData.engageList.length === 0) && (returnData.submitInfo === null || returnData.submitInfo.remark === '')) {
                this.$router.push('/motor/motorQuote')
              } else if ((returnData.engageList && returnData.engageList.length > 0) || returnData.submitInfo && Object.keys(returnData.submitInfo).length > 0 && returnData.submitInfo.remark !== '') {
                this.$router.push('/motor/motorSupplementary')
              }
            } else {
              this.$toast(resTwo.data.rtnMsg)
            }
          })
          .catch(err => {
            this.switchs = false
            Toast.clear()
            console.log(err)
            this.$toast('订单详情获取失败')
          })
      } else {
        const channelCode = list.orderStatus === '2' ? 'HeNanMotorBike' : 'DP_OWXPA'
        this.$router.push({
          name: 'motorConfirm',
          query: {
            orderId: list.orderId,
            orderNo: orderNo,
            encryptKey: list.encryptKey,
            terminalId: 'H5',
            channelCode: channelCode,
            isH5: '1'
          }
        })
      }
    },
    addOrder() {
      console.log('新增订单')
      this.$store.commit('set_motorOrderDetail', {})
      this.$router.push('/motor/baseInfo')
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  padding: 0;
  margin: 0;
}
/deep/.order_list_box {
  padding-bottom: 0.24rem;
  font-size: 0.14rem;
  .van-nav-bar {
    z-index: 10;
    height: 0.46rem;
    .van-icon {
      color: #080808;
    }
  }
  .out_box {
    width: 100%;
    height: 0.48rem;
    position: fixed;
    top: 0.46rem;
    z-index: 9;
  }
  .search_header {
    width: 100%;
    background-color: #fff;
    // height: 0.48rem;
    overflow: hidden;
    .search_icon {
      width: 0.17rem;
      height: 0.17rem;
      vertical-align: middle;
    }
    .serach_text {
      font-size: 0.12rem;
      color: #592581;
      margin-right: 0.15rem;
    }
    .van-search {
      padding: 0;
      height: 0.4rem;
      line-height: 0.4rem;
      background-color: #f9f6f6;
      margin: 0.1rem;
      border-radius: 0.27rem;
      overflow: hidden;
      .van-search__content {
        background-color: #f9f6f6;
      }
      .van-field__control {
        font-size: 0.12rem;
      }
    }
  }
  .tab_list {
    margin-bottom: 0.8rem;
    .van-tab {
      color: #999;
    }
    .van-tabs__wrap {
      position: fixed;
      top: 0.94rem;
      height: 0.44rem;
      width: 100%;
      z-index: 9;
    }
    .van-tabs__content {
      margin-top: 1.07rem;
    }
  }
  .van-tab--active {
    color: #592581 !important;
    font-weight: 600;
  }
  .van-tabs__line {
    background-color: #592581;
  }
  .empty-box {
    height: 2.5rem;
    text-align: center;
    img {
      width: 1rem;
      height: 1rem;
      margin-top: 0.7rem;
    }
  }
  .order_list {
    margin: 0.1rem 0.15rem 0;
    .order_item {
      background-color: #fff;
      padding: 0.15rem;
      border-radius: 0.08rem;
      position: relative;
      .flex_box {
        display: flex;
        align-items: center;
        margin-bottom: 0.1rem;
        color: #666;
        .amount_text {
          font-size: 0.15rem;
        }
        .amount {
          color: #f59e36;
          font-size: 0.15rem;
        }
      }
      .detail_box {
        // width: calc(100%);
        .text_box {
          // width: min-content;
          // max-width: 100%;
          display: flex;
          align-items: flex-end;
        }
      }
      .detail_text {
        font-size: 0.15rem;
        color: #f59e36;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        flex: 1;
      }
      .look_more {
        color: #592581;
      }
      .content {
        .flex_box {
          margin-bottom: 0.04rem;
        }
      }
      .footer-btn {
        display: flex;
        justify-content: flex-end;
        .btn-item {
          width: 0.8rem;
          height: 0.28rem;
          line-height: 0.28rem;
          border: 0.01rem solid #5e2589;
          border-radius: 0.24rem;
          text-align: center;
          color: #5e2589;
        }
      }
      .header {
        display: flex;
        justify-content: space-between;
        p:nth-child(1) {
          font-size: 0.16rem;
          color: #333;
          font-weight: 600;
        }
        p:nth-child(2) {
          background-color: #f2f2f2;
          width: 0.7rem;
          height: 0.26rem;
          line-height: 0.26rem;
          border-radius: 0.04rem;
          color: #999;
          text-align: center;
          font-size: 0.12rem;
        }
      }
      .pay_logo {
        width: 0.71rem;
        height: 0.71rem;
        position: absolute;
        top: 0.1rem;
        right: 0.1rem;
      }
    }
  }
  .bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0.3rem;
    position: fixed;
    bottom: -0.13rem;
    left: 50%;
    transform: translateX(-50%);
    .add-text {
      width: 0.96rem;
      height: 0.45rem;
    }
    .add {
      width: 0.52rem;
      height: 0.58rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/orderList/orderList.vue